import type { CSSProperties } from "react"

const RARITY_COLORS: Record<string, string> = {
  common: "#9d9d9d",
  rare: "#0070dd",
  epic: "#a335ee"
}

const FALLBACK_RARITY_COLOR = "#9d9d9d"

export const getRarityColor = (rarityCode: string): string =>
  RARITY_COLORS[rarityCode] ?? FALLBACK_RARITY_COLOR

export const rarityStyle = (
  item: { rarityCode: string; hasRarityDimension: boolean } | null | undefined
): CSSProperties | undefined =>
  item?.hasRarityDimension
    ? ({ "--rarity-color": getRarityColor(item.rarityCode) } as CSSProperties)
    : undefined
